import { createContext, useContext, type MutableRefObject } from 'react';

export interface DocsScrollContextValue {
  activeSlug: string;
  setActiveSlug: (slug: string) => void;
  scrollRequestRef: MutableRefObject<(slug: string) => boolean>;
}

export const DocsScrollContext = createContext<DocsScrollContextValue | null>(null);

export function useDocsScroll(): DocsScrollContextValue {
  const ctx = useContext(DocsScrollContext);
  if (!ctx) {
    throw new Error('useDocsScroll must be used inside DocsScrollContext.Provider');
  }
  return ctx;
}
